export default function PricingSection() {
  const plans = [
    {
      name: '스타터',
      price: '29,000원/월',
      period: '',
      description: '개인 및 소규모 프로젝트에 적합',
      features: [
        '월 3개 퍼널 생성',
        '기본 분석 리포트',
        '이메일 지원',
        '기본 템플릿 제공',
        '최대 1,000명 연락처'
      ],
      buttonText: '1달 무료 시작',
      popular: false
    },
    {
      name: '프로',
      price: '99,000원/월',
      period: '',
      description: '성장하는 비즈니스를 위한 완벽한 솔루션',
      features: [
        '무제한 퍼널 생성',
        '고급 분석 및 인사이트',
        'A/B 테스트 기능',
        '다채널 통합',
        '최대 10,000명 연락처',
        '우선 고객 지원',
        '커스텀 브랜딩'
      ],
      buttonText: '프로 시작하기',
      popular: true
    },
    {
      name: '엔터프라이즈',
      price: '맞춤 견적',
      period: '',
      description: '대기업을 위한 맞춤형 솔루션',
      features: [
        '무제한 모든 기능',
        '전담 계정 매니저',
        'API 접근 권한',
        '온프레미스 배포',
        '무제한 연락처',
        '24/7 전화 지원',
        '맞춤형 통합',
        '고급 보안 기능'
      ],
      buttonText: '문의하기',
      popular: false
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            모든 규모의 비즈니스를 위한 요금제
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            스타트업부터 대기업까지, 비즈니스 규모에 맞는 최적의 플랜을 선택하세요
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div 
              key={index} 
              className={`relative bg-white rounded-2xl shadow-lg p-8 ${
                plan.popular ? 'border-2 border-teal-500 transform scale-105' : 'border border-gray-200'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-teal-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                    가장 인기
                  </span>
                </div>
              )}
              
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <p className="text-gray-600 mb-4">{plan.description}</p>
                <div className="mb-4">
                  <span className="text-4xl font-bold text-gray-900">{plan.price}</span>
                  <span className="text-gray-600">{plan.period}</span>
                </div>
              </div>

              <ul className="space-y-4 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center">
                    <i className="ri-check-line text-teal-500 text-lg mr-3"></i>
                    <span className="text-gray-700">{feature}</span>
                  </li>
                ))}
              </ul>

              <button 
                className={`w-full py-3 px-6 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  plan.popular 
                    ? 'bg-teal-600 hover:bg-teal-700 text-white' 
                    : index === 0 
                      ? 'bg-teal-100 hover:bg-teal-200 text-teal-700'
                      : 'bg-gray-100 hover:bg-gray-200 text-gray-900'
                }`}
              >
                {plan.buttonText}
              </button>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            모든 플랜에는 14일 무료 체험이 포함되어 있습니다
          </p>
          <p className="text-sm text-gray-500">
            신용카드 없이도 시작할 수 있습니다 • 언제든지 취소 가능
          </p>
        </div>
      </div>
    </section>
  );
}
